export const DEFAULT_LOCATION_NAME = 'default'

export function displayLocationName(name: string | undefined | null): string | undefined {
    if (!name || name === DEFAULT_LOCATION_NAME) return undefined
    return name
}
